import React from "react";

/**
 * Motif imports
 */

import "../noProjects/NoProjects.scss";

import iconPrivacyPolicy from "../../../assets/images/privacy_policy.svg";

export default function PaansAcknowledge() {
  return (
    <div className="parent-nopaans-div">
      <div>
        <div className="parent-search-icon-div">
          <div className="search-icon-div">
            <img src={iconPrivacyPolicy} alt="Search" />
          </div>
        </div>
        <div className="parent-noprojects-text-div">Privacy Notice <br/>  acknowledgement pending</div>
        
        <div className="parent-statement-div">
          Please acknowledge the Privacy Notice through
          <br />
          the ‘Access Platform’ link above.
        </div>
        <div className="parent-statement-div">
          Once complete, return to the DDA PowerPoint Add-in
          <br />
          and click ‘Refresh’ to continue.
        </div>
      </div>
    </div>
  );
}
